import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProceedToPay {
    isLoading: boolean;
    error: string | null;
    message: string | null;
    order_id: string | null;
    purchase_type?: string;
    booking_id?: number;
    booking_data?: any;
    [key: string]: any;
}

const initialState: ProceedToPay = {
    message: null,
    isLoading: false,
    error: null,
    order_id: null,
};

const ProceedToPaySlice = createSlice({
    name: 'ProceedToPay',
    initialState,
    reducers: {
        setProceedToPay: (state: ProceedToPay, action: PayloadAction<any>) => {
            state.message = action.payload.message;
            state.order_id = action.payload.order_id;
            state.purchase_type = action.payload.purchase_type;
            state.booking_id = action.payload.booking_id;
            state.booking_data = action.payload.booking_data;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: ProceedToPay, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: ProceedToPay, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetProceedToPay: () => {
            return initialState;
        },
    },
});

export const { setProceedToPay, setloading, seterror, resetProceedToPay } = ProceedToPaySlice.actions;

export default ProceedToPaySlice.reducer;